<template>
  <div>
    <el-dialog title="收货地址" :visible.sync="value">
      <address-save
          :addressData="addressData"
          @submitSuccess="submit('submitSuccess', $event)"
          @submitError="submit('submitError', $event)"
      >
      </address-save>
    </el-dialog>
  </div>

</template>

<script>
import AddressSave from "@/components/address-save";

export default {
  components: {AddressSave},
  model: {
    prop: "show",
    event: "show"
  },
  props: {
    show: {
      default: true,
    },
    addressData: {
      default: null,
    },
  },
  computed: {
    value: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("show", val);
      }
    },
  },
  name: 'address-save-dialog',
  data() {
    return {};
  },
  mounted() {},
  methods: {
    submit(type, event) {
      this.$emit(type, event);
      if (type === 'submitSuccess') {
        this.value = false;
      }
    },
  },
}
</script>

<style scoped></style>
